var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-steps',{attrs:{"active":_vm.active,"align-center":true,"finish-status":"finish"}},_vm._l((_vm.stepList),function(item){return _c('el-step',{key:item.title,attrs:{"title":item.title}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }